import * as React from 'react';
import './index.scss';

export default class Logo2 extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className='logo2'>
        <img src={require('./images/logo2.jpg')} />
      </div>
    )
  }
}